import { render } from "./CustomPricingPlan.vue?vue&type=template&id=23da0ee4"
import script from "./CustomPricingPlan.vue?vue&type=script&lang=js"
export * from "./CustomPricingPlan.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__